function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-40.000000, -280.000000)",
  fill: "currentColor"
}, React.createElement("g", {
  transform: "translate(42.000000, 202.000000)"
}, React.createElement("g", {
  transform: "translate(0.000000, 80.000000)"
}, React.createElement("path", {
  d: "M18,36 C27.9411255,36 36,27.9411255 36,18 C36,8.0588745 27.9411255,0 18,0 C8.0588745,0 0,8.0588745 0,18 C0,27.9411255 8.0588745,36 18,36 Z M16,6.49100518 C16,6.21983051 16.2319336,6 16.5,6 C16.7761424,6 17,6.22241849 17,6.50756836 L17,11.4931638 C17.0014225,11.5908341 16.9743045,11.689931 16.9160251,11.7773501 L15,14.6513878 L15,28.4991699 C15,29.3280555 14.3342028,30 13.5,30 C12.6715729,30 12,29.3274305 12,28.4991699 L12,14.6513878 L10.0839749,11.7773501 C10.0256955,11.689931 9.99857746,11.5908341 10,11.4931638 L10,6.50756836 C10,6.2272461 10.2319336,6 10.5,6 C10.7761424,6 11,6.22788048 11,6.49100518 L11,10 C11,10.5522847 11.4477153,11 12,11 C12.5522847,11 13,10.5522847 13,10 L13,6.49769878 C13,6.22282734 13.2319336,6 13.5,6 C13.7761424,6 14,6.21484375 14,6.49769878 L14,10 C14,10.5522847 14.4477153,11 15,11 C15.5522847,11 16,10.5522847 16,10 L16,6.49100518 Z M20.455737,16.9368098 C20.6135077,16.9273587 22.7126465,15.2053223 21.8439941,9.42333984 C24.0477295,14.8995361 21,18 21,18 L21,28.9975267 C21,29.5511774 21.4438648,30 22,30 C22.5522847,30 23,29.5525106 23,29.0014977 L23,17 C24.8119233,16.815934 26,16.0135188 26,13.5 C26,11.4813448 25.3505859,7.84448242 20.1025391,6 C20.6025391,10.526123 18,10.4624339 18,13.5 C18,15.9660183 19.4008789,17 20.455737,16.9368098 Z"
})))));

var SvgLogoVegan = function SvgLogoVegan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoVegan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-vegan.7d74d54e.svg";
export { ForwardRef as ReactComponent };